import { render } from "./mobile-money-uganda.vue?vue&type=template&id=ea6e1472"
import script from "./mobile-money-uganda.vue?vue&type=script&lang=js"
export * from "./mobile-money-uganda.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__